import ReactModal from 'react-modal'
import React, { useState } from 'react'

ReactModal.setAppElement('#__next')

export default function LeadershipModal (props) {
  const { isOpen = false } = props

  return (
    <React.Fragment>
      <ReactModal
        isOpen={isOpen}
        id={
          'biomodal'
          /* String id to be applied to the content div. */
        }
        className={
          'ReactModal__Content'
          /* String className to be applied to the modal content. */
        }
        bodyOpenClassName={'no-scroll'}
        shouldFocusAfterRender={true}
        shouldCloseOverlayClick={true}
        shouldReturnFocusAfterClose={true}
      >
        {props.children}
      </ReactModal>
    </React.Fragment>
  )
}
